<template>
  <!-- <div v-if="loading">loading...</div> -->
  <component v-if="canShowContent" :is="tag" v-bind="$attrs">
    <slot :content="content"></slot>
    <CustomRenderContent
      v-show="allowDragAndDrop"
      :model="model"
      :content="content"
      :api-key="apiKey"
      :customComponents="getCustomComponents"
      :can-track="false"
    />
    <slot name="after-content" :content="content"></slot>
  </component>
  <!-- <div v-else-if="$slots['not-found']"> -->
  <div v-else>
    <slot name="not-found"></slot>
  </div>
</template>
<script>
import { useRoute } from "vue-router";
import CustomRenderContent from "@/components/organisms/RenderContent/CustomRenderContent.vue";
import { isPreviewing } from '@builder_sdk';
import { REGISTERED_COMPONENTS } from '@/init-builder.ts';

export default defineNuxtComponent({
  components: { CustomRenderContent },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    model: {
      type: String,
      required: true,
      default: 'page' 
    },
    allowDragAndDrop: {
      type: Boolean,
      default: true
    },
    callback: {
      type: Function
    },
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    canShowContent: false,
    content: null,
    loading: true
  }),
  computed: {
    apiKey() {
      return this.$env.builder.apiKey;
    },
    getCustomComponents() {
      return REGISTERED_COMPONENTS;
    },
  },
  async mounted() {
    // Re-run this check on the client in case of SSR
    this.canShowContent = this.content || isPreviewing();
    this.$emit('mounted');
  },
  async setup(props) {
    const nuxtApp = useNuxtApp();
    const data = {};
    try {
      const route = useRoute();
      const params = {};
      const previewing = route.query.previewing;

      if (props.query) params.query = props.query;
      
      const { data: content } = await useAsyncData(props.model, () => nuxtApp.$builder.getOne(props.model, params));
      
      data.content = content.value;
      data.canShowContent = !!data.content || isPreviewing() || previewing;

      if (props.callback) props.callback(data.content);
    }
    catch (err) {
      console.log(err);
    }
    return data;
  }
});
</script>
